import React from "react";
import "../css/privacy.scss";

const questions = [
  ["What currency do you use?", "All product prices, shipping charges and payments are in USD."],
  ["How much is shipping?", "Shipping is a flat $9.99 USD per order."],
  ["When will my order ship?", "Orders are normally prepared within 1–3 business days. Estimated transit is usually 5–12 business days after dispatch."],
  ["Can every country be selected?", "No. Checkout removes destinations unavailable due to sanctions, carrier limits or payment-service restrictions. Regional restrictions can also apply."],
  ["How do I pay?", "Complete the contact and delivery form and select Pay Now. You will be redirected to the secure payment flow; this website does not collect card numbers."],
  ["Can I change my delivery address?", "Email us immediately with your order number. We can only change an address before fulfilment begins."],
  ["Can I return an item?", "Contact us within 14 days of delivery. Items must meet the conditions in our Returns & Refunds policy."],
  ["How can I contact baplehollow?", "Email model@baplehollow.online. We normally reply within two business days."],
];

function Faqs() {
  return (
    <div className="three-fourths columns medium-down--one-whole offset-by-two is-hidden-offset-mobile-only">
      <h1>FAQs</h1>
      <div className="feature-divider" />
      <div className="rte">
        {questions.map(([question, answer]) => (
          <section key={question}>
            <h3>{question}</h3>
            <p>{answer}</p>
          </section>
        ))}
      </div>
    </div>
  );
}

export default Faqs;
